export * from './DriverModules'
export const driversPath = '/et/company/:companyId/driverModule'
